import Smartlook from 'smartlook-client';

type ValueOf<T> = T[keyof T];
type AnalyticsEvent = ValueOf<typeof EVENTS>;
type AttributesMap = {
  [Analytics.EVENTS.CTA_CLICKED]: {
    page_type: string;
    cta_location: string;
  };
};
type FallbackAttributesMap = {
  [Key in Exclude<AnalyticsEvent, keyof AttributesMap>]: null;
};
type ParameterizedEvent = keyof AttributesMap;
type NonParameterizedEvent = keyof FallbackAttributesMap;
type AnalyticsAttributesMap = AttributesMap & FallbackAttributesMap;

export type AnalyticsAttributes<T extends AnalyticsEvent = AnalyticsEvent> =
  AnalyticsAttributesMap[T];

const EVENTS = {
  CTA_CLICKED: 'cta_clicked',
} as const;

export class Analytics {
  static instance = new Analytics();
  static EVENTS = EVENTS;

  private constructor() {}

  private trackSafely(cb: VoidFunction) {
    if (!window.analytics?.track) {
      setTimeout(() => this.trackSafely(cb), 1000);
    } else {
      cb();
    }
  }

  public track<T extends NonParameterizedEvent = NonParameterizedEvent>(
    event: T,
  ): void;
  public track<T extends ParameterizedEvent = ParameterizedEvent>(
    event: T,
    attributes: AnalyticsAttributes<T>,
  ): void;
  public track<T extends AnalyticsEvent = AnalyticsEvent>(
    event: T,
    attributes?: AnalyticsAttributes<T>,
  ) {
    this.trackSafely(() => window.analytics?.track?.(event, attributes));

    Smartlook.track(event, attributes ?? {});
  }
}

export const mapObjectToButtonAnalyticsAttributes = (
  payload: Record<string, unknown>,
) => {
  try {
    return { internal: { content: JSON.stringify(payload) } };
  } catch (error) {
    return undefined;
  }
};
